<template>
  <div class="prompt-footer">
    <div class="checkbox-and-tooltip">
      <md-checkbox
        class="md-primary"
        :value="caseConf.dialogue.useCurrentDate"
        aria-label="AI to Use Current Date"
        data-testid="use-current-date-checkbox"
        @change="updateUseCurrentDate"
      >
        AIs to Use Current Date
      </md-checkbox>
      <help-tooltip type="info" aria-label="Use current date tooltip" data-testid="use-current-date-tooltip">
        All Character AIs will use the date the scenario is run when asked in sim.
      </help-tooltip>
    </div>
    <patient-prompt-dialog
      v-if="promptType === 'patient'"
      :style="{ 'align-self': 'flex-end' }"
      :case-conf="caseConf"
      :readonly="readonly"
      :prompt-contents="promptContents"
      title="Add New: Prompt"
      button-label="Prompt Template"
      aria-label="Add Prompt Template"
      data-testid="add-prompt-template-button"
      @update="replacePrompt"
    />
    <npc-prompt-dialog
      v-if="promptType === 'npc'"
      :style="{ 'align-self': 'flex-end' }"
      :case-conf="caseConf"
      :readonly="readonly"
      :prompt-contents="promptContents"
      title="Add New: Prompt"
      button-label="Prompt Template"
      aria-label="Add Prompt Template"
      data-testid="add-prompt-template-button"
      @update="replacePrompt"
    />
  </div>
</template>

<script>
import get from 'lodash/get';

import HelpTooltip from '~lib/common/components/HelpTooltip.vue';

import PatientPromptDialog from '../common/PromptDialog/PatientPromptContainer';
import NpcPromptDialog from '../common/PromptDialog/NpcPromptContainer';

export default {
  name: 'prompt-footer',
  components: {
    HelpTooltip,
    PatientPromptDialog,
    NpcPromptDialog
  },
  props: {
    caseConf: {
      type: Object,
      required: true,
    },
    promptType: {
      type: String,
      default: 'patient'
    },
    readonly: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    promptContents() {
      return get(this.caseConf, 'dialogue.patientPrompt.content.en');
    },
  },
  methods: {
    updateUseCurrentDate(value) {
      this.$emit('updateUseCurrentDate', value);
    },
    replacePrompt(value) {
      this.$emit('replacePrompt', value);
    }
  },
}
</script>

<style scoped>
.prompt-footer {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
}


.checkbox-and-tooltip {
  display: flex;
  align-items: center;
  justify-content: flex-start;
}

.checkbox-and-tooltip .md-checkbox {
  margin-right: 4px;
}

.checkbox-and-tooltip .help-tooltip {
  margin-top: 2px;
}
</style>